/** Lo mínimo que hace falta para nombrar un módulo. */
export interface ModuleLabelSource {
  order: number;
  /** Etiqueta con la que el material nombra al módulo ("Introducción", "Módulo 1"). */
  label?: string | null;
}

/**
 * Nombre visible de un módulo: su `label` si el curso lo define (así la
 * Introducción se llama "Introducción" y el siguiente "Módulo 1", como en el
 * material), o "Módulo {order}" (`order` es la posición en la secuencia).
 *
 * @param modulo - Módulo con `order` y, opcionalmente, `label`.
 * @param t - Traductor (clave `module`).
 */
export const moduleLabel = (
  modulo: ModuleLabelSource,
  t: (key: string) => string
): string => modulo.label?.trim() || `${t("module")} ${modulo.order}`;
